<script>
import { shippingMethodDriveProps, useShippingMethodDrive } from "./mixin";
import Planning from "@/containers/planning";
import Titre from "@/components/atoms/titre";
import Divider from "@/components/atoms/divider";
import ShippingMethodPhone from "@/containers/shipping-method/shipping-method-phone";
import ChoixSacDrive from "@/components/organisms/choix-sac-drive";

export default {
  name: "ShippingMethodDrive",
  components: {
    Planning,
    Titre,
    Divider,
    ShippingMethodPhone,
    ChoixSacDrive
  },
  props: {
    ...shippingMethodDriveProps()
  },
  setup(props) {
    const { avecSacs, error, sacsDriveIsError, montantSac, setChoixSacs } =
      useShippingMethodDrive(props);

    return { avecSacs, error, sacsDriveIsError, montantSac, setChoixSacs };
  }
};
</script>

<template>
  <div class="u-mt-xs u-mb-xs u-ml-md u-mr-md">
    <ShippingMethodPhone
      v-if="eligibleAlerteSms"
      :is-lad="false"
      :error="error"
      class="u-mx-md u-mb-lg"
    />
    <div class="u-flex u-flex-align-center u-m-md">
      <Titre
        tag="h2"
        size="xs"
      >
        Créneau horaire
      </Titre>
      <Divider
        class="u-flex-item-fluid u-ml-xs"
        dotted
      />
    </div>
    <p class="u-mt-md u-mb-lg u-ml-md">
      Merci de préciser le créneau horaire auquel vous souhaitez retirer vos produits
    </p>
    <div>
      <Planning
        v-if="service"
        :service-id="service.id"
        :infos-legales="service.info_non_retrait"
        :avec-sacs="avecSacs"
        :sacs-drive-is-error="sacsDriveIsError"
        @setSacDriveError="() => {sacsDriveIsError = true}"
        @error="(err) => {error = err}"
      >
        <ChoixSacDrive
          v-if="hasChoixSacs"
          is-drive
          :is-offert="isSacOffert"
          :consigne-sacs="consigneSacs"
          :montant-sac="montantSac"
          :is-error="sacsDriveIsError"
          @setChoixSacs="setChoixSacs"
        />
      </Planning>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
